/* jshint esversion: 6 */

import {LoggingService} from "logging/LoggingService";

/**
 * Utilitie class for HTTP requests
 */
export const RequestService = {

    sendLmsRequest: (query, data) => {
        "use strict";

        try {
            const objHTTPRequest = new XMLHttpRequest();
            objHTTPRequest.open("POST", query, false);
            objHTTPRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            if (typeof csrf_globals !== 'undefined') {
                objHTTPRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            }
            objHTTPRequest.send(data);
            // TODO <TR20181211>: Replace deprecated 'unescape' function
            return unescape(objHTTPRequest.responseText);
        } catch (error) {
            LoggingService.error(error.message, "RequestService");
        }
        return "request_error";
    },

    sendAsyncLmsRequest: (query, data) => {
        "use strict";

        return new Promise(function(resolve, reject) {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", query, true);
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            if (typeof csrf_globals !== 'undefined') {
                xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            }
            xhr.onload = function() {
                if (this.status >= 200 && this.status < 300) {
                    resolve(this.responseText);
                }
                else {
                    LoggingService.error(this.statusText, "RequestService");
                    reject("request_error");
                }
            }
            xhr.onerror = function() {
                LoggingService.error(this.statusText, "RequestService");
                reject("request_error");
            }

            xhr.send(data);
        });
    }

    // /**
    //  * sends a request
    //  *
    //  * @param {String} query
    //  * @param {String} data
    //  *
    //  * @return {String} responseText or "request_error"
    //  */
    // sendAsyncLmsRequest: async (query, data) => {
    //     "use strict";
    //
    //     const csrfHeader = csrf_globals && csrf_globals.token ? {'x-csrf-token': csrf_globals.token} : {};
    //     return fetch(query, {
    //         method: "POST",
    //         /*mode: "cors",
    //         cache: "no-cache",
    //         redirect: "follow",
    //         referrerPolicy: "no-referrer",
    //         credentials: "same-origin"*/
    //         keepalive : true,
    //         headers: {
    //             "Content-Type": "application/x-www-form-urlencoded",
    //             ...csrfHeader
    //         },
    //         body: data
    //     })
    //         .then(response => response.text())
    //         .catch(error => {
    //             LoggingService.error(error.message, "RequestService");
    //             return "request_error";
    //         });
    // }
};
